import { render, staticRenderFns } from "./footer-gray-left.vue?vue&type=template&id=71d21da1&scoped=true&"
import script from "./footer-gray-left.vue?vue&type=script&lang=js&"
export * from "./footer-gray-left.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=71d21da1&scoped=true&lang=css&"
import style1 from "./footer-gray-left.vue?vue&type=style&index=1&id=71d21da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d21da1",
  null
  
)

export default component.exports